import { Dialog, DialogContent, DialogActions, Button, Divider } from '@mui/material';
import { WarningAmber } from '@mui/icons-material';
import { PropTypes } from 'prop-types';

const WarningModal = ({ open, warningText, confirmation, onClose}) => {
  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435, fontWeight: 400 } }}
      maxWidth="xs"
      open={open}
    >
      <Divider sx={{ borderColor: '#FDC203', borderWidth: '4.5px' }}/>
      <DialogContent sx={{display: 'flex', alignItems: 'center'}}>
        <WarningAmber fontSize='large' sx={{mr: 2}}/>
        {warningText}
      </DialogContent>
      <Divider/>
      <DialogActions>
        <Button autoFocus type="submit" variant="contained" className='button red w-1/4' onClick={confirmation}>
          Yes
        </Button>
        <Button variant="contained" className='button w-1/4' onClick={onClose}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  )
}

WarningModal.propTypes = {
  open: PropTypes.bool,
  warningText: PropTypes.string,
  confirmation: PropTypes.func,
  onClose: PropTypes.func
}

WarningModal.defaultProps = {
  open: false,
  warningText: '',
  confirmation: () => {},
  onClose: () => {}
}

export default WarningModal;